import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";

import { Modal,Button } from "antd";

export function RouterPrompt(props) {
  const { when, onOK, onCancel, title, okText, cancelText, promptMessage, onOKCallback } = props;

  const history = useHistory();

  const [showPrompt, setShowPrompt] = useState(false);
  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    if (when) {
      history.block((prompt) => {
        setCurrentPath(prompt.pathname);
        setShowPrompt(true);
        return "true";
      });
    } else {
      history.block(() => {});
    }

    return () => {
      history.block(() => {});
    };
  }, [history, when]);

  const handleOK = useCallback(async () => {
    if (onOKCallback) onOKCallback();
    if (onOK) {
      const canRoute = await Promise.resolve(onOK());
      if (canRoute) {
        history.block(() => {});
        history.push(currentPath);
      }
    }
  }, [currentPath, history, onOK]);

  const handleCancel = useCallback(async () => {
    if (onCancel) {
      const canRoute = await Promise.resolve(onCancel());
      if (canRoute) {
        history.block(() => {});
        history.push(currentPath);
      }
    }
    setShowPrompt(false);
  }, [currentPath, history, onCancel]);

  return showPrompt ? (
    <Modal
      title={title}
      visible={showPrompt}
      closable={true}
      onCancel={handleCancel}
      footer={
        [
          <Button key="1" className="ant-btn ant-btn-default" onClick={handleOK}>Yes</Button>,
          <Button key="2" className="ant-btn ant-btn-primary" onClick={handleCancel}>No</Button>,
        ]
      }
    >
      {promptMessage}
    </Modal>
  ) : null;
}
